import { StampIcon } from './stamp-icon'

const FOOTER_LINKS: Record<string, { label: string; href: string }[]> = {
  Product: [
    { label: 'Features', href: '#features' },
    { label: 'Pricing', href: '#pricing' },
    { label: 'Changelog', href: '#' },
    { label: 'Status', href: '#' },
  ],
  Developers: [
    { label: 'Documentation', href: '#' },
    { label: 'API Reference', href: '#' },
    { label: 'SDK', href: '#' },
    { label: 'CLI', href: '#' },
  ],
  Resources: [
    { label: 'Blog', href: '#' },
    { label: 'Migration Guides', href: '#' },
    { label: 'SMTP Setup', href: '#' },
    { label: 'Webhooks Guide', href: '#' },
  ],
  Legal: [
    { label: 'Terms of Service', href: '/legal/terms' },
    { label: 'Privacy Policy', href: '/legal/privacy' },
    { label: 'Acceptable Use', href: '/legal/acceptable-use' },
    { label: 'DPA', href: '/legal/dpa' },
  ],
}

export function Footer() {
  return (
    <footer style={{ background: '#1a1216', color: '#fff' }}>
      <div className="section-pad" style={{ maxWidth: 1300, margin: '0 auto', paddingTop: 80, paddingBottom: 40 }}>
        {/* Top row: logo + link columns */}
        <div className="grid-footer" style={{ gap: 48, marginBottom: 60 }}>
          {/* Brand column */}
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 16 }}>
              <StampIcon size={36} variant="solid" />
              <span style={{ fontWeight: 800, fontSize: 20, letterSpacing: '-0.02em' }}>
                one-email
              </span>
            </div>
            <p style={{ fontSize: 14, color: '#a09898', lineHeight: 1.7, maxWidth: 260, marginBottom: 24 }}>
              Transactional email API with self-hosted infrastructure. Built for developers who hate overpaying.
            </p>
            <div style={{
              display: 'inline-flex', alignItems: 'center', gap: 8,
              padding: '8px 14px', background: 'rgba(255,255,255,0.05)',
              borderRadius: 8, border: '1px solid rgba(255,255,255,0.08)',
            }}>
              <div style={{
                width: 8, height: 8, borderRadius: '50%', background: '#22c55e',
                boxShadow: '0 0 6px rgba(34,197,94,0.4)',
              }} />
              <span style={{
                fontSize: 12, color: '#a09898', fontWeight: 500,
                fontFamily: "var(--oe-font-mono)",
              }}>All systems operational</span>
            </div>
          </div>

          {/* Link columns */}
          {Object.entries(FOOTER_LINKS).map(([category, links]) => (
            <div key={category}>
              <div style={{
                fontSize: 12, fontWeight: 700, color: '#fff',
                letterSpacing: '0.06em', textTransform: 'uppercase',
                marginBottom: 20,
              }}>{category}</div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
                {links.map((link) => (
                  <a
                    key={link.label}
                    href={link.href}
                    style={{
                      color: '#9a9290', textDecoration: 'none', fontSize: 14, fontWeight: 500,
                      transition: 'color 0.2s',
                    }}
                  >
                    {link.label}
                  </a>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Divider */}
        <div style={{ borderTop: '1px solid rgba(255,255,255,0.08)', paddingTop: 28 }}>
          <div className="flex-row" style={{
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: 12,
          }}>
            <span style={{ fontSize: 13, color: '#9a9290' }}>
              &copy; {new Date().getFullYear()} One-Email. All rights reserved.
            </span>
            <span style={{ fontSize: 13, color: '#9a9290' }}>
              Part of the{' '}
              <span style={{ color: '#FF6B00', fontWeight: 600 }}>One-Status</span>{' '}
              family
            </span>
          </div>
        </div>
      </div>
    </footer>
  )
}
